import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledSubtitle = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(1),
}));
